module.exports = __webpack_public_path__ + "static/media/incoterms_en.bf52af50.jpg";